import { CerFormAdapter } from '@form/cer-form-adapter';
import { CerFormPanesSettingsUtil } from '@form/cer-form-panes/cer-form-panes.service';
import { CerFormView } from '@form/cer-form-view';
import { CerFormViewSet } from '@form/cer-form-view-set';

export class DataNumberSequenceForm extends CerFormAdapter {

  public override viewSetInit(viewSet: CerFormViewSet) {

    viewSet.panes = CerFormPanesSettingsUtil.masterDetail('horizontal', true, 40);

    const view: CerFormView = DataNumberSequenceForm.viewSequenceGet();
    viewSet.viewAdd(view)
    viewSet.viewAdd(DataNumberSequenceForm.viewSequenceNumGet('id'), view);
    viewSet.viewAdd(DataNumberSequenceForm.viewSequenceLinkGet('id'), view);
  }

  private static viewSequenceGet(): CerFormView {
    const view = new CerFormView();
    view.viewMetadata = {
      name: 'nummerserier', dataApiName: 'DataNumberSequence', text: 'Nummerserier', textSingular: 'Nummerserie',
      primaryKey: 'id', baseFields: ['id', 'name', 'history']
    };

    //var userId: number = this.appStateService.appUserId();
    view.fieldMetadata = [
      { name: 'name', text: 'Navn', required: true, orderBy: 'Ascending' },
      { name: 'maskNum', text: 'Maske', tooltipText: 'Maske, f.eks. F#######', required: true },
      { name: 'nextId', text: 'Næste nummer', format: 'Integer', required: true },
      { name: 'maxId', text: 'Max nummer', format: 'Integer', required: true }
    ];

    return view;
  }

  private static viewSequenceNumGet(parentField: string = null): CerFormView {
    return new CerFormView({

      viewMetadata: {
        name: 'nummerserie-numre', dataApiName: 'DataNumberSequenceNum', text: 'Numre', textSingular: 'Nummer',
        primaryKey: 'id', parentPrimaryKey: parentField, parentForeignKey: (parentField?.length > 0 ? 'dataNumberSequence': null), 
        baseFields: ['id', 'history']
      },
      fieldMetadata: [
        { name: 'dataNumberSequence', text: 'Nummerserie', required: true, foreignKeyTableName: 'DataNumberSequence', visible: false },
        { name: 'sequenceId', text: 'Nummerisk værdi', required: true, format: 'Integer' },
        { name: 'sequenceNum', text: 'Værdi', required: true, orderBy: 'Ascending', orderByPriority: 1 },
        { name: 'isUsed', text: 'Er brugt?', required: true, format: 'CheckBox', defaultValue: false }
      ]
    });
  }

  private static viewSequenceLinkGet(parentField: string = null): CerFormView {
    return new CerFormView({

      viewMetadata: {
        name: 'nummerserie-tilknytning', dataApiName: 'DataNumberSequenceLink', text: 'Tilknytninger', textSingular: 'Tilknytning',
        primaryKey: 'id', parentPrimaryKey: parentField, parentForeignKey: (parentField?.length > 0 ? 'dataNumberSequence': null), 
        baseFields: ['id', 'history']
      },
      fieldMetadata: [
        { name: 'dataNumberSequence', text: 'Nummerserie', required: true, foreignKeyTableName: 'DataNumberSequence', visible: false },
        { name: 'dataTable', text: 'Tabel'/*  foreignKeyValue: 'name' */},
        { name: 'group', text: 'Gruppe' },
      ]
    });
  }

}